import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Utilities.
import isAuthRoute from 'app/client/utilities/isAuthRoute';

/**
 * Drop the target of a session transition once the location has left the auth
 * routes, and not earlier: every render on them still has to redirect to it.
 */
export default (redirectTo, clearRedirect) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!redirectTo || isAuthRoute(pathname)) {
      return;
    }

    clearRedirect();
  }, [pathname, redirectTo, clearRedirect]);
};
